module.exports = __webpack_public_path__ + "399cd6d05596fb4e8486df9f4c31c1d3.pdf";